import { render, staticRenderFns } from "./DashboardAdm.vue?vue&type=template&id=405b7df2&"
import script from "./DashboardAdm.vue?vue&type=script&lang=js&"
export * from "./DashboardAdm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports